// extracted by mini-css-extract-plugin
module.exports = {"IndividualLeaderboardPage":"IndividualLeaderboardPage_IndividualLeaderboardPage__33ZtT"};